const {REACT_APP_GOOGLE_API_KEY: API_KEY} = process.env

const div = document.createElement('div')

let googleServices

function loadGooglePlaceLibScript() {
  if (document.querySelector('#google-maps-place')) {
    return
  }

  const position = document.querySelector('head')
  const script = document.createElement('script')
  script.setAttribute('async', '')
  script.setAttribute('id', 'google-maps-place')
  script.onload = () => {
    _initService()
  }
  script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&language=en`
  position.appendChild(script)
}

// OOE-UI-G1: _initService() is a no-op while the Maps script is still
// downloading, so a keystroke that arrived first left `googleServices`
// undefined and `googleServices.autocomplete` threw a raw TypeError out of the
// Promise executor. Reject with a named error instead so callers can tell
// "Maps isn't ready" apart from a real lookup failure.
const MAPS_UNAVAILABLE_MESSAGE =
  'Google Maps Places library is not available yet.'

function _requireService(kind, reject) {
  if (!googleServices?.[kind]) {
    _initService()
  }
  if (!googleServices?.[kind]) {
    reject(new Error(MAPS_UNAVAILABLE_MESSAGE))
    return null
  }
  return googleServices[kind]
}

function getPlacePredictions(request) {
  return new Promise((resolve, reject) => {
    const autocomplete = _requireService('autocomplete', reject)
    if (!autocomplete) return
    autocomplete.getPlacePredictions(request, _handleCB(resolve, reject))
  })
}

function getPlaceDetails(request) {
  return new Promise((resolve, reject) => {
    const place = _requireService('place', reject)
    if (!place) return
    place.getDetails(request, _handleCB(resolve, reject))
  })
}

function getPlaceId(request) {
  return new Promise((resolve, reject) => {
    const place = _requireService('place', reject)
    if (!place) return
    place.findPlaceFromQuery(request, _handleCB(resolve, reject))
  })
}

function _initService() {
  if (!googleServices) {
    if (!window?.google?.maps?.places) {
      return
    }
    googleServices = {
      autocomplete: new window.google.maps.places.AutocompleteService(),
      place: new window.google.maps.places.PlacesService(div),
    }
  }
}

function _handleCB(resolve, reject) {
  return (result, status) => {
    // Read the status enum defensively: the callback can fire after a
    // navigation has torn `window.google` down, and that used to turn a
    // successful lookup into a TypeError.
    const serviceStatus = window?.google?.maps?.places?.PlacesServiceStatus
    if (
      status === serviceStatus?.OK ||
      status === serviceStatus?.ZERO_RESULTS
    ) {
      return resolve(result)
    }
    return reject(
      new Error('Error querying google. See console error for more infomation'),
    )
  }
}

export {
  MAPS_UNAVAILABLE_MESSAGE,
  loadGooglePlaceLibScript,
  getPlacePredictions,
  getPlaceDetails,
  _initService,
  getPlaceId,
}
